import React from 'react';

const PnLLoss = () => {
    return (
        <svg
            width="343"
            height="429"
            viewBox="0 0 343 429"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_44758_4249)">
                <rect width="343" height="359" fill="#050505" />
                <g style={{ mixBlendMode: 'color-dodge' }}>
                    <path
                        d="M-179.487 18.3056C-183.381 32.0755 -180.671 47.0508 -172.358 62.3714C-164.043 77.6948 -150.138 93.3328 -131.708 108.386C-94.8496 138.493 -39.9671 166.199 24.2045 184.346C88.3762 202.492 149.641 207.628 196.807 201.282C220.392 198.109 240.426 192.068 255.534 183.368C270.639 174.669 280.79 163.331 284.684 149.561C288.578 135.791 285.867 120.816 277.555 105.495C269.24 90.1718 255.335 74.5339 236.905 59.4802C200.047 29.3739 145.164 1.66715 80.9924 -16.4789C16.8208 -34.625 -44.444 -39.7616 -91.6105 -33.4155C-115.195 -30.2424 -135.229 -24.2016 -150.337 -15.5014C-165.442 -6.80273 -175.593 4.53576 -179.487 18.3056Z"
                        stroke="url(#paint0_linear_44758_4249)"
                        strokeOpacity="0.15"
                    />
                    <path
                        d="M-284.824 -11.4807C-290.502 8.59867 -286.544 30.4184 -274.447 52.7135C-262.348 75.0114 -242.122 97.7539 -215.33 119.638C-161.748 163.404 -81.9776 203.672 11.282 230.043C104.542 256.415 193.587 263.883 262.154 254.658C296.438 250.045 325.579 241.262 347.563 228.601C369.544 215.943 384.342 199.427 390.02 179.348C395.698 159.268 391.74 137.449 379.643 115.153C367.544 92.8556 347.319 70.113 320.527 48.2293C266.944 4.46312 187.174 -35.8051 93.9141 -62.1765C0.654562 -88.5479 -88.3907 -96.0162 -156.958 -86.7908C-191.242 -82.1779 -220.383 -73.3947 -242.367 -60.7345C-264.348 -48.076 -279.146 -31.5601 -284.824 -11.4807Z"
                        stroke="url(#paint1_linear_44758_4249)"
                        strokeOpacity="0.15"
                    />
                    <path
                        d="M-412.999 -47.7246C-420.848 -19.9676 -415.372 10.1804 -398.67 40.9621C-381.966 71.7467 -354.049 103.134 -317.082 133.329C-243.15 193.716 -133.096 249.27 -4.44204 285.65C124.212 322.03 247.061 332.335 341.669 319.606C388.974 313.242 429.193 301.121 459.544 283.643C489.893 266.166 510.346 243.35 518.195 215.593C526.044 187.836 520.568 157.688 503.865 126.906C487.162 96.1217 459.245 64.7342 422.278 34.5397C348.346 -25.8481 238.292 -81.4014 109.638 -117.781C-19.0164 -154.161 -141.865 -164.467 -236.473 -151.738C-283.778 -145.373 -323.998 -133.253 -354.349 -115.774C-384.697 -98.2973 -405.15 -75.4815 -412.999 -47.7246Z"
                        stroke="url(#paint2_linear_44758_4249)"
                        strokeOpacity="0.15"
                    />
                </g>
                <path
                    d="M237.494 288.059L237.579 288.016L216.273 278.994L216.233 279.054L237.494 288.059Z"
                    fill="#E73E6B"
                    stroke="#231F20"
                    strokeMiterlimit="10"
                />
                <path
                    d="M154.592 337.026L159.866 253.265L177.973 262.005L244.187 157.687L341.257 143.961L432.953 -33.3548L531.854 -48.1414L637.807 -190.744L676.275 -173.373L676.24 -173.328L570.168 -30.335L471.29 -14.9587L381.09 161.686L282.968 174.66L215.433 278.635L216.273 278.994L216.233 279.054L237.494 288.059L237.578 288.016L155.452 336.519L154.592 337.026Z"
                    fill="url(#paint3_linear_44758_4249)"
                />
                <path
                    d="M154.592 337.026L153.841 323.99L158.668 249.031L177.647 257.855L243.342 154.972L339.512 140.671L432.165 -36.4814L531.086 -51.0227L633.262 -188.71L637.807 -190.743L531.854 -48.1412L432.953 -33.3546L341.257 143.961L244.187 157.687L177.973 262.005L159.867 253.265L154.592 337.026Z"
                    fill="url(#paint4_linear_44758_4249)"
                    fillOpacity="0.5"
                />
                <g style={{ mixBlendMode: 'screen' }}>
                    <path
                        d="M216.233 279.054L216.273 278.994L237.579 288.016L237.494 288.059L216.233 279.054Z"
                        fill="url(#paint5_radial_44758_4249)"
                        stroke="#231F20"
                        strokeMiterlimit="10"
                    />
                </g>
                <g clipPath="url(#clip1_44758_4249)">
                    <path
                        d="M41.8382 27.8405C40.9124 28.7607 39.782 29.2203 38.447 29.2203C37.112 29.2203 35.9849 28.7607 35.0647 27.8405C34.1445 26.9203 33.685 25.7933 33.685 24.4583C33.685 23.1233 34.1445 21.9962 35.0647 21.076C35.9849 20.1558 37.112 19.6963 38.447 19.6963C39.782 19.6963 40.9113 20.1558 41.8382 21.076C42.764 21.9962 43.2269 23.1233 43.2269 24.4583C43.2269 25.7933 42.764 26.9203 41.8382 27.8405ZM36.7072 26.2439C37.1701 26.7124 37.7504 26.9472 38.4481 26.9472C39.1458 26.9472 39.7283 26.7124 40.1979 26.2439C40.6664 25.7754 40.9012 25.1794 40.9012 24.4583C40.9012 23.7371 40.6664 23.1412 40.1979 22.6727C39.7294 22.2042 39.1458 21.9694 38.4481 21.9694C37.7504 21.9694 37.1701 22.2042 36.7072 22.6727C36.2443 23.1412 36.0129 23.7371 36.0129 24.4583C36.0129 25.1794 36.2443 25.7754 36.7072 26.2439Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M46.0221 18.8678C45.6375 18.8678 45.3032 18.7269 45.0214 18.444C44.7385 18.1623 44.5977 17.828 44.5977 17.4433C44.5977 17.0587 44.7385 16.7222 45.0214 16.4337C45.3043 16.1452 45.6375 16.001 46.0221 16.001C46.4067 16.001 46.7578 16.1452 47.0407 16.4337C47.3225 16.7222 47.4645 17.0587 47.4645 17.4433C47.4645 17.828 47.3236 18.1623 47.0407 18.444C46.7578 18.7269 46.4179 18.8678 46.0221 18.8678ZM44.8682 28.9676V19.9501H47.195V28.9676H44.8682Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M54.3374 19.6973C55.3236 19.6973 56.1375 20.0282 56.7816 20.689C57.4245 21.3509 57.7465 22.2644 57.7465 23.4306V28.9674H55.4197V23.7191C55.4197 23.1175 55.2576 22.658 54.9334 22.3393C54.608 22.0207 54.1753 21.8619 53.6352 21.8619C53.0337 21.8619 52.5529 22.0486 52.1918 22.421C51.8317 22.7944 51.6506 23.3535 51.6506 24.0981V28.9674H49.3239V19.95H51.6506V20.9596C52.2153 20.1177 53.112 19.6973 54.3374 19.6973Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M64.5814 16.0908C65.363 16.0908 66.3849 16.2172 67.6473 16.4699V28.9691H65.3205V18.147C65.1517 18.1347 64.9057 18.1291 64.5814 18.1291C63.3068 18.1291 62.6695 18.7061 62.6695 19.8611V19.9516H64.1666V22.1878H62.6695V28.9691H60.3427V22.1878H59.0446V19.9516H60.3427V19.8611C60.3427 17.3487 61.756 16.0919 64.5814 16.0919V16.0908Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M76.6301 19.9501H78.9568V28.9676H76.6301V27.9031C75.9324 28.7808 74.9529 29.2203 73.6906 29.2203C72.4282 29.2203 71.4566 28.7607 70.5979 27.8405C69.7381 26.9203 69.3076 25.7933 69.3076 24.4583C69.3076 23.1233 69.737 21.9962 70.5979 21.076C71.4577 20.1558 72.4886 19.6963 73.6906 19.6963C74.9529 19.6963 75.9335 20.1357 76.6301 21.0134V19.949V19.9501ZM72.3377 26.2897C72.8062 26.7649 73.4021 27.0019 74.1233 27.0019C74.8444 27.0019 75.4426 26.7649 75.9178 26.2897C76.393 25.8145 76.6301 25.2052 76.6301 24.4594C76.6301 23.7136 76.3919 23.1043 75.9178 22.6291C75.4426 22.1539 74.8444 21.9168 74.1233 21.9168C73.4021 21.9168 72.8062 22.155 72.3377 22.6291C71.8692 23.1043 71.6344 23.7147 71.6344 24.4594C71.6344 25.204 71.8692 25.8156 72.3377 26.2897Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M83.3923 21.5013C83.6092 20.9244 83.9659 20.4917 84.4657 20.2032C84.9644 19.9147 85.5212 19.7705 86.1339 19.7705V22.3679C85.4239 22.284 84.7899 22.4282 84.2309 22.8006C83.6718 23.1729 83.3923 23.7923 83.3923 24.6577V28.968H81.0656V19.9505H83.3923V21.5013Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M89.1103 25.4144C89.4233 26.5448 90.2708 27.1094 91.6528 27.1094C92.5428 27.1094 93.2159 26.8087 93.6732 26.2071L95.5494 27.2894C94.6594 28.5764 93.349 29.2193 91.6181 29.2193C90.1266 29.2193 88.9302 28.7687 88.0291 27.8664C87.1267 26.9641 86.6761 25.8281 86.6761 24.4573C86.6761 23.0865 87.1212 21.9651 88.0112 21.0572C88.9012 20.1493 90.0427 19.6953 91.4381 19.6953C92.7608 19.6953 93.8521 20.1526 94.7119 21.0661C95.5717 21.9796 96.0011 23.11 96.0011 24.4573C96.0011 24.7581 95.9709 25.0767 95.9105 25.4133H89.1103V25.4144ZM89.0745 23.6109H93.6732C93.5413 22.9982 93.2673 22.5409 92.8525 22.2401C92.4377 21.9393 91.9659 21.7895 91.437 21.7895C90.812 21.7895 90.2943 21.9494 89.8862 22.2669C89.477 22.5856 89.2064 23.034 89.0745 23.6109Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M23.4555 19.6822C23.5886 20.3151 23.8133 20.7824 24.1409 21.11C24.1867 21.1559 24.2371 21.1995 24.2885 21.242C24.4719 20.6706 24.7704 20.1686 25.1886 19.7404C25.9321 18.9789 26.9104 18.5977 28.1247 18.5977C28.838 18.5977 29.4809 18.7553 30.0523 19.0706C30.6236 19.3859 31.0642 19.8231 31.3728 20.3822L33.4972 19.1511C32.9616 18.2466 32.2147 17.5299 31.2576 16.9999C30.2994 16.471 29.2551 16.2061 28.1247 16.2061C26.244 16.2061 24.6921 16.8277 23.4667 18.071C23.4108 18.1269 23.3582 18.184 23.3046 18.2421C23.3079 18.3774 23.3146 18.5093 23.3225 18.6346C23.3471 19.0259 23.3918 19.3781 23.4555 19.6811V19.6822Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M30.0623 26.3175C29.4854 26.6328 28.8403 26.7904 28.1258 26.7904C26.9127 26.7904 25.9332 26.4103 25.1897 25.6478C24.7782 25.2262 24.483 24.7354 24.2985 24.1797C24.2438 24.2244 24.1901 24.2703 24.1409 24.3194C23.8133 24.6471 23.5897 25.1122 23.4566 25.7428C23.394 26.038 23.3493 26.3823 23.3247 26.7647C23.3168 26.8911 23.3101 27.0208 23.3057 27.1561C23.3582 27.2131 23.4108 27.2701 23.4667 27.326C24.6921 28.5749 26.2451 29.2 28.1247 29.2C29.2674 29.2 30.3139 28.935 31.2665 28.4061C32.218 27.8772 32.9616 27.1594 33.4971 26.2549L31.3728 25.0239C31.0753 25.5717 30.6382 26.0022 30.0612 26.3175H30.0623Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M26.8612 22.5078C25.2277 22.5078 24.2303 22.0538 23.6277 21.4523C23.025 20.8508 22.7567 19.8523 22.7567 18.2188H22.4089V27.1501H22.7567C22.7567 24.0038 23.716 22.86 26.8612 22.86L28.8224 22.7672V22.5995L26.8612 22.5067V22.5078Z"
                        fill="#DFF60D"
                    />
                    <path
                        d="M17.9611 22.5078C19.5947 22.5078 20.592 22.0538 21.1947 21.4523C21.7973 20.8508 22.0657 19.8523 22.0657 18.2188H22.4134V27.1501H22.0657C22.0657 24.0038 21.1064 22.86 17.9611 22.86L16 22.7672V22.5995L17.9611 22.5067V22.5078Z"
                        fill="#DFF60D"
                    />
                </g>
            </g>
            <rect width="343" height="70" transform="translate(0 359)" fill="#F6F6F6" />
            <defs>
                <linearGradient
                    id="paint0_linear_44758_4249"
                    x1="274.973"
                    y1="134.53"
                    x2="-160.41"
                    y2="77.4562"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DFF60D" />
                    <stop offset="0.491388" stopColor="white" />
                    <stop offset="1" stopColor="#DFF60D" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_44758_4249"
                    x1="375.692"
                    y1="157.446"
                    x2="-256.889"
                    y2="74.5226"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DFF60D" />
                    <stop offset="0.491388" stopColor="white" />
                    <stop offset="1" stopColor="#DFF60D" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_44758_4249"
                    x1="498.25"
                    y1="185.332"
                    x2="-374.285"
                    y2="70.9536"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DFF60D" />
                    <stop offset="0.491388" stopColor="white" />
                    <stop offset="1" stopColor="#DFF60D" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_44758_4249"
                    x1="191.809"
                    y1="286.265"
                    x2="317.268"
                    y2="32.9366"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E73E6B" />
                    <stop offset="0.684069" stopColor="#DFF60D" />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_44758_4249"
                    x1="138.457"
                    y1="312.242"
                    x2="286.701"
                    y2="13.9991"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E73E6B" />
                    <stop offset="0.726066" stopColor="#DFF60D" />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint5_radial_44758_4249"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(226.905 283.525) rotate(175.006) scale(8.40372 7.95599)"
                >
                    <stop stopColor="#836DF3" />
                    <stop offset="0.11" stopColor="#6554BC" />
                    <stop offset="0.23" stopColor="#4A3E8B" />
                    <stop offset="0.36" stopColor="#332B60" />
                    <stop offset="0.48" stopColor="#211B3D" />
                    <stop offset="0.61" stopColor="#120F22" />
                    <stop offset="0.73" stopColor="#08060F" />
                    <stop offset="0.86" stopColor="#020103" />
                    <stop offset="1" />
                </radialGradient>
                <clipPath id="clip0_44758_4249">
                    <rect width="343" height="359" fill="white" />
                </clipPath>
                <clipPath id="clip1_44758_4249">
                    <rect width="80" height="13.2204" fill="white" transform="translate(16 16)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default PnLLoss;
